import Svg, { Path } from 'react-native-svg';

export function QnAUnFilled({ width, height, color }) {
  return (
    <>
      {/* <Svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <Path d="M6.66602 15.6C5.28185 16.7783 4.01602 17.5 1.66602 17.5C2.49935 16.6667 3.55768 15.5417 4.00018 13.7942C2.55518 12.595 1.66602 10.9642 1.66602 9.16667C1.66602 5.485 5.39685 2.5 9.99935 2.5C14.2493 2.5 17.756 5.045 18.2685 8.33333" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <Path d="M13.332 16.5745C10.5704 16.5745 8.33203 14.9162 8.33203 12.8703C8.33203 10.8253 10.5704 9.16699 13.332 9.16699C16.0937 9.16699 18.332 10.8253 18.332 12.8703C18.332 13.8695 17.7987 14.7753 16.932 15.4412C17.1962 16.412 17.832 17.037 18.332 17.5003C16.832 17.5003 16.0687 17.047 15.172 16.3153C14.602 16.482 13.982 16.5745 13.332 16.5745Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </Svg> */}
      <Svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M6.6665 15.6C5.28234 16.7783 4.0165 17.5 1.6665 17.5C2.49984 16.6667 3.55817 15.5417 4.00067 13.7942C2.55567 12.595 1.6665 10.9642 1.6665 9.16667C1.6665 5.485 5.39734 2.5 9.99984 2.5C14.2498 2.5 17.7565 5.045 18.269 8.33333"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.333 16.5742C10.5713 16.5742 8.33301 14.9158 8.33301 12.87C8.33301 10.825 10.5713 9.16667 13.333 9.16667C16.0947 9.16667 18.333 10.825 18.333 12.87C18.333 13.8692 17.7997 14.775 16.933 15.4408C17.1972 16.4117 17.833 17.0367 18.333 17.5C16.833 17.5 16.0697 17.0467 15.173 16.315C14.603 16.4817 13.983 16.5742 13.333 16.5742Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </>
  );
}
